// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__28_Xw","resendInfoText":"OnGoingPaymentBox_resendInfoText__nrj7W"};